import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

interface VetPrescriptionCounter {
  current_value: number;
}

export function useVetPrescriptionCounter(_vetUserId: string | undefined, enabled = true) {
  const { t } = useTranslation("prescriptions");
  const queryClient = useQueryClient();

  const counterQuery = useQuery({
    queryKey: ["vet-mapa-prescription-sequence"],
    queryFn: async () => {
      const { data } = await (supabase as any)
        .from("vet_mapa_prescription_sequences")
        .select("current_value")
        .maybeSingle();
      return data as VetPrescriptionCounter | null;
    },
    enabled,
  });

  const updateCounter = useMutation({
    mutationFn: async (newValue: number | { newValue: number; reason: string }) => {
      const adjustment = typeof newValue === "number" ? { newValue, reason: t("profileModal.manualAdjustmentReason") } : newValue;
      const { error } = await (supabase as any).rpc("adjust_my_vet_mapa_prescription_sequence", { p_new_value: adjustment.newValue, p_reason: adjustment.reason.trim() });
      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vet-mapa-prescription-sequence"] });
      toast.success(t("profileModal.counterUpdated"));
    },
  });

  return { counter: counterQuery.data, isLoading: counterQuery.isLoading, updateCounter };
}
